import { render, staticRenderFns } from "./DocForm.vue?vue&type=template&id=090a9be3&scoped=true&"
import script from "./DocForm.vue?vue&type=script&lang=js&"
export * from "./DocForm.vue?vue&type=script&lang=js&"
import style0 from "./DocForm.vue?vue&type=style&index=0&id=090a9be3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090a9be3",
  null
  
)

export default component.exports